import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { SetDefaultData } from '../businesses.actions'

@Component({
  selector: 'app-create-business',
  templateUrl: './create-business.component.html',
  styleUrls: ['./create-business.component.css'],
})
export class CreateBusinessComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  constructor(
    public store: Store<any>,
    private route: ActivatedRoute,
    public router: Router,
  ) {
    super()
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.store.dispatch(new SetDefaultData('create'))
  }
}
